module.exports = __webpack_public_path__ + "img/calculator-illustration-1@2x.f211d626.png";